import { Icon } from "@mui/material";
import axios from "axios";
import { format } from "date-fns"; // Import the format function from date-fns
import { useContext, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { SemesterContext } from "../context/SemesterContext";
import { UserContext } from "../context/UserContext";
import { CancelButton, ConfirmButton } from "./Button";
import SnackBar from "./SnackBar";
import FlexBox, { FlexGrow } from "./FlexBox";
import { ClickableIcon } from "./Icon";
import { StyledText, TextSize, TextStatus } from "./Text";
import defaultImg from "../assets/DefaultCardImage.png";
import Modal from "./Modal";
import SimpleDatePicker from "./SimpleDatePicker";
import Skills from "./Skills";
import { CompetencyDetailOverview } from "./CometencyDetailOverview";
import { CompetencyType, EmptyCompetencyType } from "../types/Milestone";
import { CustomDateRangePicker } from "./CustomDateRangePicker";
import { PrerequisiteWarning } from "./PrerequisiteWarning";
import dayjs from "dayjs";
import { handleJWTError } from "../hooks/jwtErrHandler";

const Header = styled.h4`
  font-family: Montserrat;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
`;
const CustomFlex = styled(FlexBox)`
  margin-bottom: 20px;
  align-items: flex-start;
`;

const LabelData = styled(StyledText)`
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.20000000298023224px;
  text-align: left;
  color: #e6e6e6;
  vertical-align: text-top;
`;
const Ul = styled.ul`
  color: #d0d0d0;
  padding-inline-start: 16px;
  margin-block-start: 0;
  margin-block-end: 0;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
`;

const StyledImg = styled.img`
  // width: 50%;
  border-right: 0.5px solid #262626;
  height: 200px;
  max-height: 25%;
  border-radius: 5px 0px 0px 5px;
  box-shadow: 5px 0px 10px #0000004a;
  // min-height: 65%;
  // margin-bottom: 10px;
`;
type CompetencyAddModalProps = {
  isAddModalOpen?: boolean;
  isStudent: boolean;
  hideAddButton?: boolean;
  data: any;
  setAddModalOpen: (x: boolean) => void;
  onAddComplete?: () => void;
  onAddError?: (err: any) => void;
  setWarningMessage?: any;
  setWarningOpen?: any;
  isSnackbarOpen?: any;
  setIsSnackbarOpen?: any;
  message?: any;
  setMessage?: any;
  fetchCompetency?: any;
  warningMessage?: string;
  isWarningOpen?: boolean;
  setIsWarningOpen: (x: boolean) => void;
  // setIsSnackbarOpen: (x: boolean) => void;
  // setIsErrorOpen: (x: boolean) => void;
  // setMessage?: any;
  // setErrorMessage?: any;
};

const CompetencyAddModalNew = ({
  isAddModalOpen,
  hideAddButton,
  setAddModalOpen,
  data,
  setIsSnackbarOpen,
  message,
  setMessage,
  fetchCompetency,
  setWarningMessage,
  setIsWarningOpen,
}: CompetencyAddModalProps): JSX.Element => {
  const [isCalendarOpen, setIsCalendarOpen] = useState<boolean>(false);
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const currentUser = useContext(UserContext).user;
  const [errorMessage, setErrorMessage] = useState<string>("");

  const semesterContext = useContext(SemesterContext);
  const [skillView, setSkillView] = useState(false);
  const [warningView, setWarningView] = useState(false);

  const [startDate, setStartDate] = useState<any>(
    data?.semester_detail?.start_date
      ? data?.semester_detail?.start_date?.includes("UTC")
        ? dayjs(data.semester_detail.start_date.split(" 00")[0])
        : dayjs(data.semester_detail.start_date)
      : dayjs(semesterContext.selectedSemester?.start_date)
  );
  const [endDate, setEndDate] = useState<any>(
    data?.semester_detail?.end_date
      ? data.semester_detail.start_date.includes("UTC")
        ? data.semester_detail.end_date.split(" 00")[0]
        : data.semester_detail.end_date
      : semesterContext.selectedSemester?.end_date
  );

  const [competencyDetail, setCompetencyDetail] =
    useState<CompetencyType>(EmptyCompetencyType);

  const [pendingMilestoneAdd, setPendingMilestoneAdd] = useState<boolean>(false);

  useEffect(() => {
    setSkillView(false);
    fetchCompetencyDetail(data);
  }, [data]);
  const fetchCompetencyDetail = (data: any) => {
    var url = `/competency/detail?competency_code=${data.competency_code}&university_code=CMKL&curriculum_version=${data.curriculum_version}&semester_name=${semesterContext.selectedSemester?.label}`;
    if (semesterContext.selectedSemester?.label === "All") {
      url = `/competency/detail?competency_code=${data.competency_code}&university_code=CMKL&curriculum_version=${data.curriculum_version}`;
    }
    axios
      .get(url)
      .then((res) => {
        // setCompetency(res.data.competency);
        setCompetencyDetail(res.data.competency);

        if (res.data?.competency?.semester_detail?.end_date) {
          setEndDate(
            res.data.competency.semester_detail.start_date.includes("UTC")
              ? res.data.competency.semester_detail.end_date.split(" 00")[0]
              : res.data.competency.semester_detail.end_date
          );
        }
        else {
          setEndDate(
            dayjs(semesterContext.selectedSemester?.end_date))
        }

        if (res.data?.competency?.semester_detail?.start_date) {
          setStartDate(
            res.data.competency.semester_detail.start_date.includes("UTC")
              ? res.data.competency.semester_detail.start_date.split(" 00")[0]
              : res.data.competency.semester_detail.start_date)
        }
        else {
          setStartDate(
            dayjs(semesterContext.selectedSemester?.start_date))
        }




      })
      .catch(function (error) {
        handleJWTError(error);
        setCompetencyDetail(EmptyCompetencyType);
        setErrorMessage(error?.response?.data?.error);
        setIsErrorOpen(true);
        setAddModalOpen(false);
      });
  };

  const addCompetency = () => {
    if (!startDate || !endDate) {
      setErrorMessage("Select valid start and end dates!");
      // setErrorMessage(res.data.roadmaps[0].message);
      setIsErrorOpen(true);
    } else if (
      format(new Date(startDate), "yyyy-MM-dd") ===
      format(new Date(endDate), "yyyy-MM-dd")
    ) {
      setErrorMessage("Start Date and End date cannot be the same!");
      // setErrorMessage(res.data.roadmaps[0].message);
      setIsErrorOpen(true);
    } else {
      setPendingMilestoneAdd(true)
      axios
        .post("/roadmap/milestones/new", {
          student_id: currentUser.id,
          competency_template_id: competencyDetail.id,
          title: competencyDetail.title,
          description: competencyDetail.description,
          start_date: format(new Date(startDate), "yyyy-MM-dd"),
          target_date: format(new Date(endDate), "yyyy-MM-dd"),
          year: Number(semesterContext.selectedSemester?.year),
          semester: semesterContext.selectedSemester?.label,
          program_name: currentUser?.programs?.[0]?.program_name,
        })
        .then((res) => {
          setPendingMilestoneAdd(false);
          if (
            res?.data?.roadmaps[0]?.message &&
            res?.data?.roadmaps[0]?.message !== ""
          ) {
            setWarningMessage(res.data.roadmaps[0].message);
            setIsWarningOpen && setIsWarningOpen(true);
            setAddModalOpen(false);
            fetchCompetency();
            setMessage("Your competency has been added");
            setIsSnackbarOpen(true);
          } else {
            setMessage("Your competency has been added");
            setIsSnackbarOpen(true);
            // setIsCalendarOpen(false);
            setAddModalOpen(false);
            fetchCompetency();
            // setTimeout(() => {
            //   setAddModalOpen(false);
            // }, 4000);
          }
        })
        .catch(function (error) {
          setPendingMilestoneAdd(false);
          handleJWTError(error);
          if (error?.response) {
            setErrorMessage(
              error?.response?.data?.error || "Failed to add competency!"
            );
            setIsErrorOpen(true);
          } else if (error?.request) {
            console.log(error.request);
          } else if (error?.response?.data.error) {
            setErrorMessage(error?.response?.data?.error);
            setIsErrorOpen(true);
          }
        });
    }
  };

  const showPrerequisiteWarning = () => {
    setSkillView(false);
    setWarningView(true);
  };

  return (
    <>
      <SnackBar
        isOpen={isErrorOpen}
        setOpen={setIsErrorOpen}
        header="Error!"
        message={errorMessage}
        type="error"
      />

      <Modal
        isOpen={isAddModalOpen || false}
        setOpen={setAddModalOpen}
        customStyle={{
          content: {
            maxWidth: "1000px",
            padding: 0,
            background: "#090d20",
            border: "1px solid #2D416C",
            boxShadow: "0px 4px 16px rgba(0,0,0)",
            borderRadius: "8px",
            marginTop: warningView && !isCalendarOpen ? "5%" : 30,
          },
        }}
      >
        {" "}
        <FlexGrow style={{ padding: 20 }}>
          <CustomFlex>
            <FlexGrow>
              <Header>
                [{competencyDetail.competency_code}] {competencyDetail.title}
              </Header>
            </FlexGrow>
            <ClickableIcon
              name="times"
              onClick={() => setAddModalOpen(false)}
            />
          </CustomFlex>

          {
            // isCalendarOpen ? (
            //   <CustomDateRangePicker
            //     startDate={dayjs(startDate).format("YYYY-MM-DD")}
            //     endDate={dayjs(endDate).format("YYYY-MM-DD")}
            //     setStartDate={setStartDate}
            //     setEndDate={setEndDate}
            //   />
            // ) :
            warningView ? (
              <PrerequisiteWarning
                prerequisites={competencyDetail?.prerequisites}
              />
            ) : skillView ? (
              <Skills
                setSkillView={setSkillView}
                selectedRow={competencyDetail?.skills}
              />
            ) : (
              <>
                <FlexBox style={{ marginBottom: 20, gap: 10 }}>
                  {competencyDetail?.required && (
                    <FlexBox>
                      <Icon
                        title="Required for graduation"
                        sx={{
                          color: "yellow",
                          paddingRight: "5px",
                          // boxShadow: "0 4px 4px #0000007a",
                        }}
                      >
                        star
                      </Icon>
                      Required for Graduation
                    </FlexBox>
                  )}
                  {competencyDetail?.prerequisites?.length > 0 && (
                    <FlexBox>
                      <Icon
                        title="Prerequisites Exist"
                        sx={{
                          color: "#00ff00",
                          paddingRight: "5px",
                          // boxShadow: "0 4px 4px #0000007a",
                        }}
                      >
                        add_task
                      </Icon>
                      Prerequisites Exist
                    </FlexBox>
                  )}
                  {competencyDetail?.semester_detail?.assessment_only ===
                    true && (
                      <FlexBox>
                        <Icon
                          title="Required for graduation"
                          sx={{
                            color: "yellow",
                            paddingRight: "5px",
                            // boxShadow: "0 4px 4px #0000007a",
                          }}
                        >
                          warning
                        </Icon>
                        Assessment Only
                      </FlexBox>
                    )}
                </FlexBox>

                <div
                  style={{
                    display: "flex",
                    background: "rgba(171, 171, 171, 0.1)",
                    borderRadius: 5,
                    // padding: 10,
                  }}
                >
                  <StyledImg
                    src={
                      competencyDetail?.graphics?.imgurl
                        ? process.env.REACT_APP_IMG_URL +
                        competencyDetail?.graphics?.imgurl
                        : defaultImg
                    }
                    alt=""
                  />
                  <div
                    className="visible-scrollbar"
                    style={{
                      padding: "20px",
                      maxHeight: 150,
                      overflow: "auto",
                    }}
                  >
                    {competencyDetail?.description}
                  </div>
                </div>
                {competencyDetail?.semester_detail?.is_attendance_required && <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    background: "linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 152, 0, 0.1) 100%)",
                    border: "1px solid rgba(255, 193, 7, 0.3)",
                    borderLeft: "4px solid #ffc107",
                    borderRadius: 8,
                    padding: "12px 16px",
                    marginTop: 16,
                    marginBottom: 8,
                    boxShadow: "0 2px 8px rgba(255, 193, 7, 0.1)",
                  }}
                >
                  <Icon
                    title="Attendance Required"
                    sx={{
                      color: "#ffc107",
                      fontSize: "24px",
                      marginRight: "12px",
                      flexShrink: 0,
                    }}
                  >
                    how_to_reg
                  </Icon>
                  <span
                    style={{
                      color: "#f57c00",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      fontWeight: 500,
                    }}
                  >
                    Students must attend lectures as defined by the instructor to earn this competency
                  </span>
                </div>}

                <CompetencyDetailOverview
                  data={competencyDetail}
                  setSkillView={setSkillView}
                />
              </>
            )}
        </FlexGrow>
        <FlexBox
          justify="end"
          style={{ padding: "0px 20px 20px 20px", gap: 20 }}
        >
          {currentUser.role === 1 &&
            !hideAddButton &&
            (
              // !isCalendarOpen ? 
              (
                warningView ? (
                  <>
                    <CancelButton
                      style={{ cursor: pendingMilestoneAdd ? 'not-allowed' : 'pointer' }}
                      width="200px"
                      onClick={() => !pendingMilestoneAdd && setAddModalOpen(false)}
                    >
                      Cancel
                    </CancelButton>
                    <ConfirmButton
                      style={{ cursor: pendingMilestoneAdd ? 'not-allowed' : 'pointer' }}
                      onClick={() => {
                        // setIsCalendarOpen(true);
                        !pendingMilestoneAdd && addCompetency()
                      }}
                    >
                      + ADD TO ROAD MAP
                    </ConfirmButton>
                  </>
                ) : (semesterContext.selectedSemester?.is_open &&
                  <ConfirmButton
                    style={{ cursor: pendingMilestoneAdd ? 'not-allowed' : 'pointer' }}
                    onClick={() => {
                      if (!pendingMilestoneAdd) {
                        competencyDetail?.prerequisites?.length > 0
                          ? showPrerequisiteWarning()
                          :
                          // setIsCalendarOpen(true);
                          addCompetency();
                      }
                    }}
                  >
                    + ADD TO ROAD MAP
                  </ConfirmButton>
                )
              )
              // : (
              //   <ConfirmButton
              //     disabled={true}
              //     onClick={() => {
              //       addCompetency();
              //     }}
              //   >
              //     Confirm
              //   </ConfirmButton>
              // )
            )}
        </FlexBox>
      </Modal>
    </>
  );
};

export default CompetencyAddModalNew;
